import InvoiceLifecycle from "../assets/InvoiceLifecycle.png"

const CustomersStarter = ({ setCreateCustomer }) => {
    return (
        <div className="_2fnj">
            <div className="clarions-pods">
                <h3>A business without people is not pleasant</h3>
                <span className="frumpy-gel">All in one location, create and manage your contacts.</span>
                <button onClick={() => setCreateCustomer(true)}>New Customer</button>
            </div>
            {/* <div className="bistro-sale">
                <img src={InvoiceLifecycle} alt="" />
            </div> */}
        </div>
    )
}

export default CustomersStarter

